module.exports = __webpack_public_path__ + "static/media/bgContacto.e250b32c.jpg";